import { render, staticRenderFns } from "./select-input.vue?vue&type=template&id=56bdc9e7&scoped=true"
import script from "./select-input.vue?vue&type=script&lang=js"
export * from "./select-input.vue?vue&type=script&lang=js"
import style0 from "./select-input.vue?vue&type=style&index=0&id=56bdc9e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bdc9e7",
  null
  
)

export default component.exports